import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../App';

/**
 * RequireAuth — Iter 198
 *
 * Drop-in wrapper for protected `<Route element={…}>` elements that:
 *   1. Redirects unauthenticated users to /signin
 *   2. Captures the originating path + search (e.g. "/safety-bulletin?town=Almeria")
 *      and forwards it via `location.state.from`, so SignIn can land them back
 *      where they started instead of dumping them on /discover.
 *
 * Optional `condition(user)` predicate lets callers gate on role too — used
 * for /business/dashboard which requires both auth AND role === "business".
 * If the predicate fails for an *authenticated* user we still redirect to
 * /signin (re-using the same redirect flow); SignIn's existing role-based
 * fallback handles the rest.
 */
const RequireAuth = ({ children, condition }) => {
  const { user } = useAuth();
  const location = useLocation();
  const ok = condition ? condition(user) : !!user;
  if (ok) return children;
  const from = `${location.pathname}${location.search || ''}`;
  return <Navigate to="/signin" state={{ from }} replace />;
};

export default RequireAuth;
